export default __webpack_public_path__ + "static/media/3.7f3fe17e.webp";